import { ensureUniqId } from '@/common/util/svg'

const importers = {
  paypal: () =>
    import(
      /* webpackChunkName: "kr-asset-paypal" */
      '@/assets/images/icons/regular/payment_methods/paypal.svg'
    ),
  paypalNative: () =>
    import(
      /* webpackChunkName: "kr-asset-paypal_native" */
      '@/assets/images/icons/regular/payment_methods/paypal_native.svg'
    ),
  paypalBnplNative: () =>
    import(
      /* webpackChunkName: "kr-asset-paypal_bnpl_native" */
      '@/assets/images/icons/regular/payment_methods/paypal_bnpl_native.svg'
    ),
  bizum: () =>
    import(
      /* webpackChunkName: "kr-asset-bizum" */
      '@/assets/images/icons/regular/payment_methods/bizum.svg'
    )
}

const asset = importer => async () => ensureUniqId((await importer()).default)

export const assets = {
  regular: {
    branded: {
      KADEOS_CULTURE: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-kadeos_culture" */ '@/assets/images/icons/regular/brands/kadeos_culture.svg'
            )
          ).default
        ),
      KADEOS_GIFT: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-kadeos_gift" */ '@/assets/images/icons/regular/brands/kadeos_gift.svg'
            )
          ).default
        ),
      TUYA: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-tuya" */ '@/assets/images/icons/regular/brands/tuya.svg'
            )
          ).default
        ),
      COLSUBSIDIO: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-colsubsidio" */ '@/assets/images/icons/regular/payment_methods/colsubsidio.svg'
            )
          ).default
        ),
      CARNET: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-carnet" */ '@/assets/images/icons/regular/brands/carnet.svg'
            )
          ).default
        ),
      CONECS: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-conecs" */ '@/assets/images/icons/regular/brands/conecs.svg'
            )
          ).default
        ),
      DINERS: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-diners" */ '@/assets/images/icons/regular/brands/diners.svg'
            )
          ).default
        ),
      SODEXO: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-sodexo" */ '@/assets/images/icons/regular/brands/pluxee.svg'
            )
          ).default
        ),
      EDENRED_CO: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-edenred_co" */ '@/assets/images/icons/regular/brands/edenred_co.svg'
            )
          ).default
        ),
      EDENRED_TR: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-edenred_co" */ '@/assets/images/icons/regular/brands/edenred_co.svg'
            )
          ).default
        ),
      EDENRED_TC: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-edenred_co" */ '@/assets/images/icons/regular/brands/edenred_co.svg'
            )
          ).default
        ),
      EDENRED_SC: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-edenred_co" */ '@/assets/images/icons/regular/brands/edenred_co.svg'
            )
          ).default
        ),
      EDENRED_EC: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-edenred_co" */ '@/assets/images/icons/regular/brands/edenred_co.svg'
            )
          ).default
        ),
      CHQ_DEJ: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-chq_dej" */ '@/assets/images/icons/regular/brands/chq_dej.svg'
            )
          ).default
        ),
      APETIZ: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-bimpli" */ '@/assets/images/icons/regular/brands/bimpli.svg'
            )
          ).default
        ),
      MASTERCARD: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-mastercard" */ '@/assets/images/icons/regular/brands/mastercard.svg'
            )
          ).default
        ),
      MASTERCARD_DEBIT: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-mastercard_debit" */ '@/assets/images/icons/regular/brands/mastercard_debit.svg'
            )
          ).default
        ),
      AMEX: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-amex" */ '@/assets/images/icons/regular/brands/amex.svg'
            )
          ).default
        ),
      CB: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-cb" */ '@/assets/images/icons/regular/brands/cb.svg'
            )
          ).default
        ),
      MAESTRO: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-maestro" */ '@/assets/images/icons/regular/brands/maestro.svg'
            )
          ).default
        ),
      BANCONTACT: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-bancontact" */ '@/assets/images/icons/regular/brands/bancontact.svg'
            )
          ).default
        ),
      VISA: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-visa" */ '@/assets/images/icons/regular/brands/visa.svg'
            )
          ).default
        ),
      VISA_DEBIT: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-visa" */ '@/assets/images/icons/regular/brands/visa.svg'
            )
          ).default
        ),
      VISA_CREDIT: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-visa" */ '@/assets/images/icons/regular/brands/visa.svg'
            )
          ).default
        ),
      VISA_ELECTRON: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-visa_electron" */ '@/assets/images/icons/regular/brands/visa_electron.svg'
            )
          ).default
        ),
      VPAY: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-vpay" */ '@/assets/images/icons/regular/brands/vpay.svg'
            )
          ).default
        ),
      CABAL: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-cabal" */ '@/assets/images/icons/regular/brands/cabal.svg'
            )
          ).default
        ),
      CABAL_DEBIT: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-cabal" */ '@/assets/images/icons/regular/brands/cabal.svg'
            )
          ).default
        ),
      DCC: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-planet_dcc" */ '@/assets/images/icons/regular/brands/planet_dcc.svg'
            )
          ).default
        ),
      CMR: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-cmr" */ '@/assets/images/icons/regular/brands/cmr.svg'
            )
          ).default
        ),
      DISCOVER: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-discover" */ '@/assets/images/icons/regular/brands/discover.svg'
            )
          ).default
        ),
      OSB: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-osb" */ '@/assets/images/icons/regular/brands/osb.svg'
            )
          ).default
        ),
      PRV_SMART_CARD: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-prv_smart_card" */ '@/assets/images/icons/regular/brands/prv_smart_card.svg'
            )
          ).default
        ),
      PRV_OPT: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-prv_opt" */ '@/assets/images/icons/regular/brands/prv_opt.svg'
            )
          ).default
        ),
      'E-CARTEBLEUE': async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-e_cartebleue" */ '@/assets/images/icons/regular/brands/e_cartebleue.svg'
            )
          ).default
        ),
      JCB: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-jcb" */ '@/assets/images/icons/regular/brands/jcb.svg'
            )
          ).default
        ),
      NARANJA: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-naranja" */ '@/assets/images/icons/regular/brands/naranja.svg'
            )
          ).default
        ),
      AURA: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-aura" */ '@/assets/images/icons/regular/brands/aura.svg'
            )
          ).default
        ),
      ELO: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-elo" */ '@/assets/images/icons/regular/brands/elo.svg'
            )
          ).default
        ),
      HIPER: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-hiper" */ '@/assets/images/icons/regular/brands/hiper.svg'
            )
          ).default
        ),
      HIPERCARD: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-hipercard" */ '@/assets/images/icons/regular/brands/hipercard.svg'
            )
          ).default
        ),
      PRV_BDP: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-prv_bdp" */ '@/assets/images/icons/regular/brands/prv_bdp.svg'
            )
          ).default
        ),
      PRV_SOC: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-prv_socredo" */ '@/assets/images/icons/regular/brands/prv_socredo.svg'
            )
          ).default
        ),
      SOL: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-sol" */ '@/assets/images/icons/regular/brands/sol.svg'
            )
          ).default
        ),
      ILLICADO: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-illicado" */ '@/assets/images/icons/regular/payment_methods/illicado.svg'
            )
          ).default
        ),
      OGLOBA: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-ogloba" */ '@/assets/images/icons/regular/payment_methods/ogloba.svg'
            )
          ).default
        ),
      UNION_PAY: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-union_pay" */ '@/assets/images/icons/regular/payment_methods/union_pay.svg'
            )
          ).default
        ),
      OG_PB: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-og_pb" */ '@/assets/images/icons/regular/brands/og_pb.svg'
            )
          ).default
        )
    }
  },
  outline: {
    branded: {
      DINERS: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-diners_outline" */ '@/assets/images/icons/regular/brands/diners_outline.svg'
            )
          ).default
        )
    }
  },
  error: {
    pan: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-error-card" */ '@/assets/images/icons/errors/fields/card.svg'
          )
        ).default
      ),
    expiryDate: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-error-expiry" */ '@/assets/images/icons/errors/fields/expiry.svg'
          )
        ).default
      ),
    securityCode: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-error-securityCode" */ '@/assets/images/icons/errors/fields/securityCode.svg'
          )
        ).default
      ),
    identityDocumentNumber: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-error-idCard" */ '@/assets/images/icons/errors/fields/idCard.svg'
          )
        ).default
      ),
    cardHolderName: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-error-cardName" */ '@/assets/images/icons/errors/fields/cardName.svg'
          )
        ).default
      ),
    cardHolderMail: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-error-cardMail" */ '@/assets/images/icons/errors/fields/cardMail.svg'
          )
        ).default
      ),
    branded: {
      KADEOS_CULTURE: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-error-kadeos_culture" */ '@/assets/images/icons/errors/brands/kadeos_culture.svg'
            )
          ).default
        ),
      KADEOS_GIFT: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-error-kadeos_gift" */ '@/assets/images/icons/errors/brands/kadeos_gift.svg'
            )
          ).default
        ),
      TUYA: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-error-tuya" */ '@/assets/images/icons/errors/brands/tuya.svg'
            )
          ).default
        ),
      COLSUBSIDIO: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-error-colsubsidio" */ '@/assets/images/icons/errors/brands/colsubsidio.svg'
            )
          ).default
        ),

      CARNET: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-error-carnet" */ '@/assets/images/icons/errors/brands/carnet.svg'
            )
          ).default
        ),
      CONECS: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-error-conecs" */ '@/assets/images/icons/errors/brands/conecs.svg'
            )
          ).default
        ),
      DINERS: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-error-diners" */ '@/assets/images/icons/errors/brands/diners.svg'
            )
          ).default
        ),
      SODEXO: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-error-sodexo" */ '@/assets/images/icons/errors/brands/pluxee.svg'
            )
          ).default
        ),
      EDENRED_CO: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-error-edenred_co" */ '@/assets/images/icons/errors/brands/edenred_co.svg'
            )
          ).default
        ),
      CHQ_DEJ: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-error-chq_dej" */ '@/assets/images/icons/errors/brands/chq_dej.svg'
            )
          ).default
        ),
      APETIZ: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-error-bimpli" */ '@/assets/images/icons/errors/brands/bimpli.svg'
            )
          ).default
        ),
      MASTERCARD: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-error-mastercard" */ '@/assets/images/icons/errors/brands/mastercard.svg'
            )
          ).default
        ),
      MASTERCARD_DEBIT: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-error-mastercard_debit" */ '@/assets/images/icons/errors/brands/mastercard_debit.svg'
            )
          ).default
        ),
      AMEX: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-error-amex" */ '@/assets/images/icons/errors/brands/amex.svg'
            )
          ).default
        ),
      CB: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-error-cb" */ '@/assets/images/icons/errors/brands/cb.svg'
            )
          ).default
        ),
      MAESTRO: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-error-maestro" */ '@/assets/images/icons/errors/brands/maestro.svg'
            )
          ).default
        ),
      BANCONTACT: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-error-bancontact" */ '@/assets/images/icons/errors/brands/bancontact.svg'
            )
          ).default
        ),
      VISA: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-error-visa" */ '@/assets/images/icons/errors/brands/visa.svg'
            )
          ).default
        ),
      VISA_DEBIT: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-error-visa_debit" */ '@/assets/images/icons/errors/brands/visa_debit.svg'
            )
          ).default
        ),
      VISA_CREDIT: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-error-visa" */ '@/assets/images/icons/errors/brands/visa.svg'
            )
          ).default
        ),
      VISA_ELECTRON: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-error-visa_electron" */ '@/assets/images/icons/errors/brands/visa_electron.svg'
            )
          ).default
        ),
      VPAY: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-error-vpay" */ '@/assets/images/icons/errors/brands/vpay.svg'
            )
          ).default
        ),
      CABAL: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-error-cabal" */ '@/assets/images/icons/errors/brands/cabal.svg'
            )
          ).default
        ),
      CABAL_DEBIT: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-error-cabal" */ '@/assets/images/icons/errors/brands/cabal.svg'
            )
          ).default
        ),
      DCC: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-error-planet_dcc" */ '@/assets/images/icons/errors/brands/planet_dcc.svg'
            )
          ).default
        ),
      CMR: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-error-cmr" */ '@/assets/images/icons/errors/brands/cmr.svg'
            )
          ).default
        ),
      DISCOVER: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-error-discover" */ '@/assets/images/icons/errors/brands/discover.svg'
            )
          ).default
        ),
      OSB: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-error-osb" */ '@/assets/images/icons/errors/brands/osb.svg'
            )
          ).default
        ),
      PRV_SMART_CARD: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-error-prv_smart_card" */ '@/assets/images/icons/errors/brands/prv_smart_card.svg'
            )
          ).default
        ),
      'E-CARTEBLEUE': async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-error-e_cartebleue" */ '@/assets/images/icons/errors/brands/e_cartebleue.svg'
            )
          ).default
        ),
      JCB: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-error-jcb" */ '@/assets/images/icons/errors/brands/jcb.svg'
            )
          ).default
        ),
      NARANJA: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-error-naranja" */ '@/assets/images/icons/errors/brands/naranja.svg'
            )
          ).default
        ),
      AURA: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-error-aura" */ '@/assets/images/icons/errors/brands/aura.svg'
            )
          ).default
        ),
      ELO: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-error-elo" */ '@/assets/images/icons/errors/brands/elo.svg'
            )
          ).default
        ),
      HIPER: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-error-hiper" */ '@/assets/images/icons/errors/brands/hiper.svg'
            )
          ).default
        ),
      HIPERCARD: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-error-hipercard" */ '@/assets/images/icons/errors/brands/hipercard.svg'
            )
          ).default
        ),
      PRV_BDP: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-error-prv_bdp" */ '@/assets/images/icons/errors/brands/prv_bdp.svg'
            )
          ).default
        ),
      PRV_SOC: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-error-prv_socredo" */ '@/assets/images/icons/errors/brands/prv_socredo.svg'
            )
          ).default
        ),
      SOL: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-error-sol" */ '@/assets/images/icons/errors/brands/sol.svg'
            )
          ).default
        ),
      ILLICADO: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-error-illicado" */ '@/assets/images/icons/errors/brands/illicado.svg'
            )
          ).default
        ),
      OGLOBA: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-error-ogloba" */ '@/assets/images/icons/errors/brands/ogloba.svg'
            )
          ).default
        ),
      UNION_PAY: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-error-union_pay" */ '@/assets/images/icons/errors/brands/union_pay.svg'
            )
          ).default
        )
    }
  },
  help: {
    securityCode: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-help-security_code" */ '@/assets/images/icons/help_securityCode.svg'
          )
        ).default
      ),
    securityCodeAmex: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-help-security_code_amex" */ '@/assets/images/icons/help_securityCode_amex.svg'
          )
        ).default
      )
  },
  visibility: {
    on: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-visibility-on" */ '@/assets/images/icons/visibility.svg'
          )
        ).default
      ),
    off: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-visibility-off" */ '@/assets/images/icons/visibilityOff.svg'
          )
        ).default
      )
  },
  paymentMethods: {
    regular: {
      BIZUM: asset(importers.bizum),
      BIZUM_NATIVE: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-bizum_native" */ '@/assets/images/icons/regular/payment_methods/bizum_native.svg'
            )
          ).default
        ),
      PSE: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-pse" */ '@/assets/images/icons/regular/payment_methods/pse.svg'
            )
          ).default
        ),
      FRANFINANCE: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-franfinance" */ '@/assets/images/icons/regular/payment_methods/franfinance.svg'
            )
          ).default
        ),
      FRANFINANCE_3X: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-franfinance" */ '@/assets/images/icons/regular/payment_methods/franfinance.svg'
            )
          ).default
        ),
      FRANFINANCE_4X: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-franfinance" */ '@/assets/images/icons/regular/payment_methods/franfinance.svg'
            )
          ).default
        ),
      SEPA: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-sepa" */ '@/assets/images/icons/regular/payment_methods/sepa.svg'
            )
          ).default
        ),
      EFECTY: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-efecty" */ '@/assets/images/icons/regular/payment_methods/efecty.svg'
            )
          ).default
        ),
      PAGOEFECTIVO: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-pagoefectivo" */ '@/assets/images/icons/regular/payment_methods/pagoefectivo.svg'
            )
          ).default
        ),
      PIX: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-pix" */ '@/assets/images/icons/regular/payment_methods/pix.svg'
            )
          ).default
        ),
      IP_WIRE: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-ip_wire" */ '@/assets/images/icons/regular/payment_methods/ip_wire.svg'
            )
          ).default
        ),
      IP_WIRE_INST: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-ip_wire" */ '@/assets/images/icons/regular/payment_methods/ip_wire.svg'
            )
          ).default
        ),
      AVWU: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-avwu" */ '@/assets/images/icons/regular/payment_methods/avwu.svg'
            )
          ).default
        ),
      BALOTO: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-baloto" */ '@/assets/images/icons/regular/payment_methods/baloto.svg'
            )
          ).default
        ),
      RED_AVAL: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-red_aval" */ '@/assets/images/icons/regular/payment_methods/red_aval.svg'
            )
          ).default
        ),
      INTERRAPIDISIMO: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-interrapidisimo" */ '@/assets/images/icons/regular/payment_methods/interrapidisimo.svg'
            )
          ).default
        ),
      SURED: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-sured" */ '@/assets/images/icons/regular/payment_methods/sured.svg'
            )
          ).default
        ),
      MOVIL_RED: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-movil_red" */ '@/assets/images/icons/regular/payment_methods/movil_red.svg'
            )
          ).default
        ),
      EXITO_CASH: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-exito_cash" */ '@/assets/images/icons/regular/payment_methods/exito_cash.svg'
            )
          ).default
        ),
      BANCOLOMBIA_IP: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-bancolombia" */ '@/assets/images/icons/regular/payment_methods/bancolombia.svg'
            )
          ).default
        ),
      NEQUI: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-nequi" */ '@/assets/images/icons/regular/payment_methods/nequi.svg'
            )
          ).default
        ),
      NEQUI_NATIVE: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-nequi_native" */ '@/assets/images/icons/regular/payment_methods/nequi_native.svg'
            )
          ).default
        ),
      APPLE_PAY: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-apple_pay" */ '@/assets/images/icons/regular/payment_methods/apple_pay.svg'
            )
          ).default
        ),
      APPLE_PAY_NATIVE: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-apple_pay_native" */ '@/assets/images/icons/regular/payment_methods/apple_pay_native.svg'
            )
          ).default
        ),
      PAYPAL: asset(importers.paypal),
      PAYPAL_SB: asset(importers.paypal),
      PAYPAL_BNPL: asset(importers.paypal),
      PAYPAL_BNPL_SB: asset(importers.paypal),
      PAYPAL_NATIVE: asset(importers.paypalNative),
      PAYPAL_SB_NATIVE: asset(importers.paypalNative),
      PAYPAL_BNPL_NATIVE: asset(importers.paypalBnplNative),
      PAYPAL_BNPL_SB_NATIVE: asset(importers.paypalBnplNative),
      ALMA: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-alma" */ '@/assets/images/icons/regular/payment_methods/alma.svg'
            )
          ).default
        ),
      ALMA_2X: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-alma" */ '@/assets/images/icons/regular/payment_methods/alma.svg'
            )
          ).default
        ),
      ALMA_3X: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-alma" */ '@/assets/images/icons/regular/payment_methods/alma.svg'
            )
          ).default
        ),
      ALMA_4X: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-alma" */ '@/assets/images/icons/regular/payment_methods/alma.svg'
            )
          ).default
        ),
      ALMA_10X: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-alma" */ '@/assets/images/icons/regular/payment_methods/alma.svg'
            )
          ).default
        ),
      ALMA_12X: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-alma" */ '@/assets/images/icons/regular/payment_methods/alma.svg'
            )
          ).default
        ),
      COFIDIS: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-cofidis" */ '@/assets/images/icons/regular/payment_methods/cofidis.svg'
            )
          ).default
        ),
      COFIDIS_DFPAY_FR: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-cofidis_dfpay" */ '@/assets/images/icons/regular/payment_methods/cofidis_dfpay.svg'
            )
          ).default
        ),
      COFIDIS_FRAC_ES: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-cofidis_frac_es" */ '@/assets/images/icons/regular/payment_methods/cofidis_frac_es.svg'
            )
          ).default
        ),
      COFIDIS_LOAN_BE: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-cofidis_loan_be" */ '@/assets/images/icons/regular/payment_methods/cofidis_loan_be.svg'
            )
          ).default
        ),
      COFIDIS_LOAN_CB: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-cofidis_loan_cb" */ '@/assets/images/icons/regular/payment_methods/cofidis_loan_cb.svg'
            )
          ).default
        ),
      COFIDIS_LOAN_ES: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-cofidis_loan_es" */ '@/assets/images/icons/regular/payment_methods/cofidis_loan_es.svg'
            )
          ).default
        ),
      COFIDIS_LOAN_FR: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-cofidis_loan_fr" */ '@/assets/images/icons/regular/payment_methods/cofidis_loan_fr.svg'
            )
          ).default
        ),
      COFIDIS_LOAN_IT: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-cofidis_loan_it" */ '@/assets/images/icons/regular/payment_methods/cofidis_loan_it.svg'
            )
          ).default
        ),
      COFIDIS_PAY_FR: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-cofidis_pay_fr" */ '@/assets/images/icons/regular/payment_methods/cofidis_pay_fr.svg'
            )
          ).default
        ),
      COFIDIS_4X_ES: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-cofidis_4x" */ '@/assets/images/icons/regular/payment_methods/cofidis_4x.svg'
            )
          ).default
        ),
      COFIDIS_4X_FR: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-cofidis_4x" */ '@/assets/images/icons/regular/payment_methods/cofidis_4x.svg'
            )
          ).default
        ),
      COFIDIS_3X_BE: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-cofidis_3x" */ '@/assets/images/icons/regular/payment_methods/cofidis_3x.svg'
            )
          ).default
        ),
      COFIDIS_3X_FR: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-cofidis_3x" */ '@/assets/images/icons/regular/payment_methods/cofidis_3x.svg'
            )
          ).default
        ),
      SICREDI_BOLETO: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-sicredi_boleto" */ '@/assets/images/icons/regular/payment_methods/sicredi_boleto.svg'
            )
          ).default
        ),
      BRADESCO_BOLETO: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-bradesco" */ '@/assets/images/icons/regular/payment_methods/bradesco.svg'
            )
          ).default
        ),
      SICOOB_BOLETO: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-sicoob" */ '@/assets/images/icons/regular/payment_methods/sicoob.svg'
            )
          ).default
        ),
      PAYCONIQ: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-payconiq" */ '@/assets/images/icons/regular/payment_methods/payconiq.svg'
            )
          ).default
        ),
      UPI: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-upi" */ '@/assets/images/icons/regular/payment_methods/upi.svg'
            )
          ).default
        ),
      MULTIBANCO: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-multibanco" */ '@/assets/images/icons/regular/payment_methods/multibanco.svg'
            )
          ).default
        ),
      MB_WAY: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-mb_way" */ '@/assets/images/icons/regular/payment_methods/mb_way.svg'
            )
          ).default
        ),
      WEBPAY_PLUS: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-web_pay_plus" */ '@/assets/images/icons/regular/payment_methods/web_pay_plus.svg'
            )
          ).default
        ),
      GOOGLEPAY: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-google_pay" */ '@/assets/images/icons/regular/payment_methods/google_pay.svg'
            )
          ).default
        ),
      GOOGLEPAY_NATIVE: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-google_pay_native" */ '@/assets/images/icons/regular/payment_methods/google_pay_native.svg'
            )
          ).default
        ),
      ALINEA: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-alinea" */ '@/assets/images/icons/regular/payment_methods/alinea.svg'
            )
          ).default
        ),
      ALINEA_SB: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-alinea" */ '@/assets/images/icons/regular/payment_methods/alinea.svg'
            )
          ).default
        ),
      AUCHAN: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-auchan" */ '@/assets/images/icons/regular/payment_methods/auchan.svg'
            )
          ).default
        ),
      AUCHAN_SB: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-auchan" */ '@/assets/images/icons/regular/payment_methods/auchan.svg'
            )
          ).default
        ),
      BOULANGER: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-boulanger" */ '@/assets/images/icons/regular/payment_methods/boulanger.svg'
            )
          ).default
        ),
      BOULANGER_SB: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-boulanger" */ '@/assets/images/icons/regular/payment_methods/boulanger.svg'
            )
          ).default
        ),
      NORAUTO: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-norauto" */ '@/assets/images/icons/regular/payment_methods/norauto.svg'
            )
          ).default
        ),
      NORAUTO_SB: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-norauto" */ '@/assets/images/icons/regular/payment_methods/norauto.svg'
            )
          ).default
        ),
      ONEY: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-oney" */ '@/assets/images/icons/regular/payment_methods/oney.svg'
            )
          ).default
        ),
      ONEY_3X_4X: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-oney_3x_4x" */ '@/assets/images/icons/regular/payment_methods/oney_3x_4x.svg'
            )
          ).default
        ),
      ONEY_10X_12X: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-oney_10x_12x" */ '@/assets/images/icons/regular/payment_methods/oney_10x_12x.svg'
            )
          ).default
        ),
      ONEY_ENSEIGNE: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-oney_enseigne" */ '@/assets/images/icons/regular/payment_methods/oney_enseigne.svg'
            )
          ).default
        ),
      ONEY_PAYLATER: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-oney_paylater" */ '@/assets/images/icons/regular/payment_methods/oney_paylater.svg'
            )
          ).default
        ),
      PICWIC: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-picwic" */ '@/assets/images/icons/regular/payment_methods/picwic.svg'
            )
          ).default
        ),
      PICWIC_SB: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-picwic" */ '@/assets/images/icons/regular/payment_methods/picwic.svg'
            )
          ).default
        ),
      CASH_LATAM: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-cash_latam" */ '@/assets/images/icons/regular/payment_methods/cash_latam.svg'
            )
          ).default
        ),
      CVCO: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-cvco" */ '@/assets/images/icons/regular/payment_methods/cvco.svg'
            )
          ).default
        ),
      ALIPAY_PLUS: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-alipay_plus" */ '@/assets/images/icons/regular/payment_methods/alipay_plus.svg'
            )
          ).default
        ),
      AKULAKU_PAYLATER: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-akulaku_paylater" */ '@/assets/images/icons/regular/payment_methods/akulaku_paylater.svg'
            )
          ).default
        ),
      ALIPAY_CN: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-alipay_cn" */ '@/assets/images/icons/regular/payment_methods/alipay_cn.svg'
            )
          ).default
        ),
      ALIPAY_HK: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-alipay_hk" */ '@/assets/images/icons/regular/payment_methods/alipay_hk.svg'
            )
          ).default
        ),
      BILLEASE: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-billease" */ '@/assets/images/icons/regular/payment_methods/billease.svg'
            )
          ).default
        ),
      BOOST: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-boost" */ '@/assets/images/icons/regular/payment_methods/boost.svg'
            )
          ).default
        ),
      BPI: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-bpi" */ '@/assets/images/icons/regular/payment_methods/bpi.svg'
            )
          ).default
        ),
      DANA: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-dana" */ '@/assets/images/icons/regular/payment_methods/dana.svg'
            )
          ).default
        ),
      GCASH: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-gcash" */ '@/assets/images/icons/regular/payment_methods/gcash.svg'
            )
          ).default
        ),
      KAKAOPAY: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-kakaopay" */ '@/assets/images/icons/regular/payment_methods/kakaopay.svg'
            )
          ).default
        ),
      KREDIVO_ID: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-kredivo_id" */ '@/assets/images/icons/regular/payment_methods/kredivo_id.svg'
            )
          ).default
        ),
      MAYA: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-maya" */ '@/assets/images/icons/regular/payment_methods/maya.svg'
            )
          ).default
        ),
      MPAY: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-mpay" */ '@/assets/images/icons/regular/payment_methods/mpay.svg'
            )
          ).default
        ),
      RABBIT_LINE_PAY: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-rabbit_line_pay" */ '@/assets/images/icons/regular/payment_methods/rabbit_line_pay.svg'
            )
          ).default
        ),
      TNG: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-tng" */ '@/assets/images/icons/regular/payment_methods/tng.svg'
            )
          ).default
        ),
      TRUEMONEY: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-truemoney" */ '@/assets/images/icons/regular/payment_methods/truemoney.svg'
            )
          ).default
        ),
      FLOA: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-floa" */ '@/assets/images/icons/regular/payment_methods/floa.svg'
            )
          ).default
        ),
      FLOA_3X: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-floa_3x" */ '@/assets/images/icons/regular/payment_methods/floa_3x.svg'
            )
          ).default
        ),
      FLOA_4X: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-floa_4x" */ '@/assets/images/icons/regular/payment_methods/floa_4x.svg'
            )
          ).default
        ),
      FLOA_10X: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-floa_10x" */ '@/assets/images/icons/regular/payment_methods/floa_10x.svg'
            )
          ).default
        ),
      FLOA_PAYLATER: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-floa_paylater" */ '@/assets/images/icons/regular/payment_methods/floa_paylater.svg'
            )
          ).default
        ),
      TRANSFIYA: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-transfiya" */ '@/assets/images/icons/regular/payment_methods/transfiya.svg'
            )
          ).default
        ),
      WECHAT_PAY: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-wechatpay" */ '@/assets/images/icons/regular/payment_methods/wechat_pay.svg'
            )
          ).default
        ),
      TOSS: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-toss" */ '@/assets/images/icons/regular/payment_methods/toss.svg'
            )
          ).default
        ),
      SAMSUNG_PAY: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-samsung_pay" */ '@/assets/images/icons/regular/payment_methods/samsung_pay.svg'
            )
          ).default
        ),
      SAMSUNG_PAY_NATIVE: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-samsung_pay_native" */ '@/assets/images/icons/regular/payment_methods/samsung_pay_native.svg'
            )
          ).default
        ),
      COLSUBSIDIO: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-colsubsidio" */ '@/assets/images/icons/regular/payment_methods/colsubsidio.svg'
            )
          ).default
        ),
      ILLICADO: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-illicado" */ '@/assets/images/icons/regular/payment_methods/illicado.svg'
            )
          ).default
        ),
      OGLOBA: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-ogloba" */ '@/assets/images/icons/regular/payment_methods/ogloba.svg'
            )
          ).default
        ),
      HUB_PISP: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-hub_pisp" */ '@/assets/images/icons/regular/payment_methods/hub_pisp.svg'
            )
          ).default
        ),
      HUB_PISP_INST: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-hub_pisp" */ '@/assets/images/icons/regular/payment_methods/hub_pisp.svg'
            )
          ).default
        ),
      DAVIPLATA: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-daviplata" */ '@/assets/images/icons/regular/payment_methods/daviplata.svg'
            )
          ).default
        ),
      WERO: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-wero" */ '@/assets/images/icons/regular/payment_methods/wero.svg'
            )
          ).default
        ),
      WERO_NATIVE: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-wero_native" */ '@/assets/images/icons/regular/payment_methods/wero_native.svg'
            )
          ).default
        ),
      TWINT: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-twint" */ '@/assets/images/icons/regular/payment_methods/twint.svg'
            )
          ).default
        ),
      UNION_PAY_QR: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-union_pay" */ '@/assets/images/icons/regular/payment_methods/union_pay.svg'
            )
          ).default
        ),
      OG_PB: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-og_pb-payment-method" */ '@/assets/images/icons/regular/payment_methods/og_pb.svg'
            )
          ).default
        ),
      BRE_B: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-bre_b-payment-method" */ '@/assets/images/icons/regular/payment_methods/bre_b.svg'
            )
          ).default
        ),
      BRE_B_M: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-bre_b-payment-method" */ '@/assets/images/icons/regular/payment_methods/bre_b.svg'
            )
          ).default
        ),
      PUNTOS_COLOMBIA: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-puntos_colombia-payment-method" */ '@/assets/images/icons/regular/payment_methods/puntos_colombia.svg'
            )
          ).default
        ),
      ENTRECUENTAS: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-entrecuentas-payment-method" */ '@/assets/images/icons/regular/payment_methods/entrecuentas.svg'
            )
          ).default
        )
    },
    compact: {
      APPLE_PAY: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-compact-apple_pay" */ '@/assets/images/icons/regular/payment_methods/compact/apple_pay.svg'
            )
          ).default
        ),
      GOOGLEPAY: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-compact-google_pay" */ '@/assets/images/icons/regular/payment_methods/compact/google_pay.svg'
            )
          ).default
        ),
      BIZUM_NATIVE: asset(importers.bizum),
      PAYPAL_NATIVE: asset(importers.paypal),
      PAYPAL_SB_NATIVE: asset(importers.paypal),
      PAYPAL_BNPL_NATIVE: asset(importers.paypal),
      PAYPAL_BNPL_SB_NATIVE: asset(importers.paypal),
      SAMSUNG_PAY_NATIVE: async () =>
        ensureUniqId(
          (
            await import(
              /* webpackChunkName: "kr-asset-compact-samsung_pay_native" */ '@/assets/images/icons/regular/payment_methods/compact/samsung_pay_native.svg'
            )
          ).default
        )
    }
  },
  flags: {
    AF: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-af" */ '@/assets/images/icons/flags/af.svg'
          )
        ).default
      ),
    AL: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-al" */ '@/assets/images/icons/flags/al.svg'
          )
        ).default
      ),
    DZ: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-dz" */ '@/assets/images/icons/flags/dz.svg'
          )
        ).default
      ),
    AS: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-as" */ '@/assets/images/icons/flags/as.svg'
          )
        ).default
      ),
    AD: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-ad" */ '@/assets/images/icons/flags/ad.svg'
          )
        ).default
      ),
    AO: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-ao" */ '@/assets/images/icons/flags/ao.svg'
          )
        ).default
      ),
    AI: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-ai" */ '@/assets/images/icons/flags/ai.svg'
          )
        ).default
      ),
    AQ: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-aq" */ '@/assets/images/icons/flags/aq.svg'
          )
        ).default
      ),
    AG: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-ag" */ '@/assets/images/icons/flags/ag.svg'
          )
        ).default
      ),
    AR: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-ar" */ '@/assets/images/icons/flags/ar.svg'
          )
        ).default
      ),
    AM: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-am" */ '@/assets/images/icons/flags/am.svg'
          )
        ).default
      ),
    AW: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-aw" */ '@/assets/images/icons/flags/aw.svg'
          )
        ).default
      ),
    AU: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-au" */ '@/assets/images/icons/flags/au.svg'
          )
        ).default
      ),
    AT: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-at" */ '@/assets/images/icons/flags/at.svg'
          )
        ).default
      ),
    AZ: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-az" */ '@/assets/images/icons/flags/az.svg'
          )
        ).default
      ),
    BS: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-bs" */ '@/assets/images/icons/flags/bs.svg'
          )
        ).default
      ),
    BH: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-bh" */ '@/assets/images/icons/flags/bh.svg'
          )
        ).default
      ),
    BD: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-bd" */ '@/assets/images/icons/flags/bd.svg'
          )
        ).default
      ),
    BB: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-bb" */ '@/assets/images/icons/flags/bb.svg'
          )
        ).default
      ),
    BY: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-by" */ '@/assets/images/icons/flags/by.svg'
          )
        ).default
      ),
    BE: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-be" */ '@/assets/images/icons/flags/be.svg'
          )
        ).default
      ),
    BZ: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-bz" */ '@/assets/images/icons/flags/bz.svg'
          )
        ).default
      ),
    BJ: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-bj" */ '@/assets/images/icons/flags/bj.svg'
          )
        ).default
      ),
    BM: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-bm" */ '@/assets/images/icons/flags/bm.svg'
          )
        ).default
      ),
    BT: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-bt" */ '@/assets/images/icons/flags/bt.svg'
          )
        ).default
      ),
    BO: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-bo" */ '@/assets/images/icons/flags/bo.svg'
          )
        ).default
      ),
    BA: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-ba" */ '@/assets/images/icons/flags/ba.svg'
          )
        ).default
      ),
    BW: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-bw" */ '@/assets/images/icons/flags/bw.svg'
          )
        ).default
      ),
    BR: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-br" */ '@/assets/images/icons/flags/br.svg'
          )
        ).default
      ),
    IO: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-io" */ '@/assets/images/icons/flags/io.svg'
          )
        ).default
      ),
    BN: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-bn" */ '@/assets/images/icons/flags/bn.svg'
          )
        ).default
      ),
    BG: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-bg" */ '@/assets/images/icons/flags/bg.svg'
          )
        ).default
      ),
    BF: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-bf" */ '@/assets/images/icons/flags/bf.svg'
          )
        ).default
      ),
    BI: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-bi" */ '@/assets/images/icons/flags/bi.svg'
          )
        ).default
      ),
    KH: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-kh" */ '@/assets/images/icons/flags/kh.svg'
          )
        ).default
      ),
    CM: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-cm" */ '@/assets/images/icons/flags/cm.svg'
          )
        ).default
      ),
    CA: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-ca" */ '@/assets/images/icons/flags/ca.svg'
          )
        ).default
      ),
    CV: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-cv" */ '@/assets/images/icons/flags/cv.svg'
          )
        ).default
      ),
    KY: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-ky" */ '@/assets/images/icons/flags/ky.svg'
          )
        ).default
      ),
    CF: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-cf" */ '@/assets/images/icons/flags/cf.svg'
          )
        ).default
      ),
    TD: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-td" */ '@/assets/images/icons/flags/td.svg'
          )
        ).default
      ),
    CL: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-cl" */ '@/assets/images/icons/flags/cl.svg'
          )
        ).default
      ),
    CN: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-cn" */ '@/assets/images/icons/flags/cn.svg'
          )
        ).default
      ),
    CX: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-cx" */ '@/assets/images/icons/flags/cx.svg'
          )
        ).default
      ),
    CC: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-cc" */ '@/assets/images/icons/flags/cc.svg'
          )
        ).default
      ),
    CO: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-co" */ '@/assets/images/icons/flags/co.svg'
          )
        ).default
      ),
    KM: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-km" */ '@/assets/images/icons/flags/km.svg'
          )
        ).default
      ),
    CG: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-cg" */ '@/assets/images/icons/flags/cg.svg'
          )
        ).default
      ),
    CD: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-cd" */ '@/assets/images/icons/flags/cd.svg'
          )
        ).default
      ),
    CK: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-ck" */ '@/assets/images/icons/flags/ck.svg'
          )
        ).default
      ),
    CR: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-cr" */ '@/assets/images/icons/flags/cr.svg'
          )
        ).default
      ),
    CI: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-ci" */ '@/assets/images/icons/flags/ci.svg'
          )
        ).default
      ),
    HR: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-hr" */ '@/assets/images/icons/flags/hr.svg'
          )
        ).default
      ),
    CU: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-cu" */ '@/assets/images/icons/flags/cu.svg'
          )
        ).default
      ),
    CW: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-cw" */ '@/assets/images/icons/flags/cw.svg'
          )
        ).default
      ),
    CY: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-cy" */ '@/assets/images/icons/flags/cy.svg'
          )
        ).default
      ),
    CZ: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-cz" */ '@/assets/images/icons/flags/cz.svg'
          )
        ).default
      ),
    DK: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-dk" */ '@/assets/images/icons/flags/dk.svg'
          )
        ).default
      ),
    DJ: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-dj" */ '@/assets/images/icons/flags/dj.svg'
          )
        ).default
      ),
    DM: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-dm" */ '@/assets/images/icons/flags/dm.svg'
          )
        ).default
      ),
    DO: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-do" */ '@/assets/images/icons/flags/do.svg'
          )
        ).default
      ),
    DO: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-do" */ '@/assets/images/icons/flags/do.svg'
          )
        ).default
      ),
    DO: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-do" */ '@/assets/images/icons/flags/do.svg'
          )
        ).default
      ),
    EC: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-ec" */ '@/assets/images/icons/flags/ec.svg'
          )
        ).default
      ),
    EG: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-eg" */ '@/assets/images/icons/flags/eg.svg'
          )
        ).default
      ),
    SV: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-sv" */ '@/assets/images/icons/flags/sv.svg'
          )
        ).default
      ),
    GQ: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-gq" */ '@/assets/images/icons/flags/gq.svg'
          )
        ).default
      ),
    ER: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-er" */ '@/assets/images/icons/flags/er.svg'
          )
        ).default
      ),
    EE: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-ee" */ '@/assets/images/icons/flags/ee.svg'
          )
        ).default
      ),
    SZ: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-sz" */ '@/assets/images/icons/flags/sz.svg'
          )
        ).default
      ),
    ET: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-et" */ '@/assets/images/icons/flags/et.svg'
          )
        ).default
      ),
    FK: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-fk" */ '@/assets/images/icons/flags/fk.svg'
          )
        ).default
      ),
    FO: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-fo" */ '@/assets/images/icons/flags/fo.svg'
          )
        ).default
      ),
    FJ: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-fj" */ '@/assets/images/icons/flags/fj.svg'
          )
        ).default
      ),
    FI: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-fi" */ '@/assets/images/icons/flags/fi.svg'
          )
        ).default
      ),
    FR: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-fr" */ '@/assets/images/icons/flags/fr.svg'
          )
        ).default
      ),
    GF: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-gf" */ '@/assets/images/icons/flags/gf.svg'
          )
        ).default
      ),
    PF: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-pf" */ '@/assets/images/icons/flags/pf.svg'
          )
        ).default
      ),
    TF: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-tf" */ '@/assets/images/icons/flags/tf.svg'
          )
        ).default
      ),
    GA: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-ga" */ '@/assets/images/icons/flags/ga.svg'
          )
        ).default
      ),
    GM: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-gm" */ '@/assets/images/icons/flags/gm.svg'
          )
        ).default
      ),
    GE: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-ge" */ '@/assets/images/icons/flags/ge.svg'
          )
        ).default
      ),
    DE: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-de" */ '@/assets/images/icons/flags/de.svg'
          )
        ).default
      ),
    GH: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-gh" */ '@/assets/images/icons/flags/gh.svg'
          )
        ).default
      ),
    GI: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-gi" */ '@/assets/images/icons/flags/gi.svg'
          )
        ).default
      ),
    GR: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-gr" */ '@/assets/images/icons/flags/gr.svg'
          )
        ).default
      ),
    GL: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-gl" */ '@/assets/images/icons/flags/gl.svg'
          )
        ).default
      ),
    GD: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-gd" */ '@/assets/images/icons/flags/gd.svg'
          )
        ).default
      ),
    GP: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-gp" */ '@/assets/images/icons/flags/gp.svg'
          )
        ).default
      ),
    GU: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-gu" */ '@/assets/images/icons/flags/gu.svg'
          )
        ).default
      ),
    GT: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-gt" */ '@/assets/images/icons/flags/gt.svg'
          )
        ).default
      ),
    GG: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-gg" */ '@/assets/images/icons/flags/gg.svg'
          )
        ).default
      ),
    GN: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-gn" */ '@/assets/images/icons/flags/gn.svg'
          )
        ).default
      ),
    GW: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-gw" */ '@/assets/images/icons/flags/gw.svg'
          )
        ).default
      ),
    GY: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-gy" */ '@/assets/images/icons/flags/gy.svg'
          )
        ).default
      ),
    HT: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-ht" */ '@/assets/images/icons/flags/ht.svg'
          )
        ).default
      ),
    HM: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-hm" */ '@/assets/images/icons/flags/hm.svg'
          )
        ).default
      ),
    VA: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-va" */ '@/assets/images/icons/flags/va.svg'
          )
        ).default
      ),
    HN: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-hn" */ '@/assets/images/icons/flags/hn.svg'
          )
        ).default
      ),
    HK: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-hk" */ '@/assets/images/icons/flags/hk.svg'
          )
        ).default
      ),
    HU: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-hu" */ '@/assets/images/icons/flags/hu.svg'
          )
        ).default
      ),
    IS: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-is" */ '@/assets/images/icons/flags/is.svg'
          )
        ).default
      ),
    IN: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-in" */ '@/assets/images/icons/flags/in.svg'
          )
        ).default
      ),
    ID: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-id" */ '@/assets/images/icons/flags/id.svg'
          )
        ).default
      ),
    IR: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-ir" */ '@/assets/images/icons/flags/ir.svg'
          )
        ).default
      ),
    IQ: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-iq" */ '@/assets/images/icons/flags/iq.svg'
          )
        ).default
      ),
    IE: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-ie" */ '@/assets/images/icons/flags/ie.svg'
          )
        ).default
      ),
    IM: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-im" */ '@/assets/images/icons/flags/im.svg'
          )
        ).default
      ),
    IL: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-il" */ '@/assets/images/icons/flags/il.svg'
          )
        ).default
      ),
    IT: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-it" */ '@/assets/images/icons/flags/it.svg'
          )
        ).default
      ),
    JM: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-jm" */ '@/assets/images/icons/flags/jm.svg'
          )
        ).default
      ),
    JM: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-jm" */ '@/assets/images/icons/flags/jm.svg'
          )
        ).default
      ),
    JP: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-jp" */ '@/assets/images/icons/flags/jp.svg'
          )
        ).default
      ),
    JE: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-je" */ '@/assets/images/icons/flags/je.svg'
          )
        ).default
      ),
    JO: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-jo" */ '@/assets/images/icons/flags/jo.svg'
          )
        ).default
      ),
    KZ: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-kz" */ '@/assets/images/icons/flags/kz.svg'
          )
        ).default
      ),
    KE: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-ke" */ '@/assets/images/icons/flags/ke.svg'
          )
        ).default
      ),
    KI: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-ki" */ '@/assets/images/icons/flags/ki.svg'
          )
        ).default
      ),
    KP: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-kp" */ '@/assets/images/icons/flags/kp.svg'
          )
        ).default
      ),
    KR: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-kr" */ '@/assets/images/icons/flags/kr.svg'
          )
        ).default
      ),
    KW: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-kw" */ '@/assets/images/icons/flags/kw.svg'
          )
        ).default
      ),
    KG: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-kg" */ '@/assets/images/icons/flags/kg.svg'
          )
        ).default
      ),
    XK: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-xk" */ '@/assets/images/icons/flags/xk.svg'
          )
        ).default
      ),
    LA: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-la" */ '@/assets/images/icons/flags/la.svg'
          )
        ).default
      ),
    LV: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-lv" */ '@/assets/images/icons/flags/lv.svg'
          )
        ).default
      ),
    LB: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-lb" */ '@/assets/images/icons/flags/lb.svg'
          )
        ).default
      ),
    LS: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-ls" */ '@/assets/images/icons/flags/ls.svg'
          )
        ).default
      ),
    LR: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-lr" */ '@/assets/images/icons/flags/lr.svg'
          )
        ).default
      ),
    LY: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-ly" */ '@/assets/images/icons/flags/ly.svg'
          )
        ).default
      ),
    LI: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-li" */ '@/assets/images/icons/flags/li.svg'
          )
        ).default
      ),
    LT: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-lt" */ '@/assets/images/icons/flags/lt.svg'
          )
        ).default
      ),
    LU: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-lu" */ '@/assets/images/icons/flags/lu.svg'
          )
        ).default
      ),
    MO: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-mo" */ '@/assets/images/icons/flags/mo.svg'
          )
        ).default
      ),
    MG: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-mg" */ '@/assets/images/icons/flags/mg.svg'
          )
        ).default
      ),
    MW: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-mw" */ '@/assets/images/icons/flags/mw.svg'
          )
        ).default
      ),
    MY: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-my" */ '@/assets/images/icons/flags/my.svg'
          )
        ).default
      ),
    MV: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-mv" */ '@/assets/images/icons/flags/mv.svg'
          )
        ).default
      ),
    ML: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-ml" */ '@/assets/images/icons/flags/ml.svg'
          )
        ).default
      ),
    MT: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-mt" */ '@/assets/images/icons/flags/mt.svg'
          )
        ).default
      ),
    MH: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-mh" */ '@/assets/images/icons/flags/mh.svg'
          )
        ).default
      ),
    MQ: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-mq" */ '@/assets/images/icons/flags/mq.svg'
          )
        ).default
      ),
    MR: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-mr" */ '@/assets/images/icons/flags/mr.svg'
          )
        ).default
      ),
    MU: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-mu" */ '@/assets/images/icons/flags/mu.svg'
          )
        ).default
      ),
    YT: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-yt" */ '@/assets/images/icons/flags/yt.svg'
          )
        ).default
      ),
    MX: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-mx" */ '@/assets/images/icons/flags/mx.svg'
          )
        ).default
      ),
    FM: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-fm" */ '@/assets/images/icons/flags/fm.svg'
          )
        ).default
      ),
    MD: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-md" */ '@/assets/images/icons/flags/md.svg'
          )
        ).default
      ),
    MC: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-mc" */ '@/assets/images/icons/flags/mc.svg'
          )
        ).default
      ),
    MN: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-mn" */ '@/assets/images/icons/flags/mn.svg'
          )
        ).default
      ),
    ME: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-me" */ '@/assets/images/icons/flags/me.svg'
          )
        ).default
      ),
    MS: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-ms" */ '@/assets/images/icons/flags/ms.svg'
          )
        ).default
      ),
    MA: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-ma" */ '@/assets/images/icons/flags/ma.svg'
          )
        ).default
      ),
    MZ: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-mz" */ '@/assets/images/icons/flags/mz.svg'
          )
        ).default
      ),
    MM: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-mm" */ '@/assets/images/icons/flags/mm.svg'
          )
        ).default
      ),
    NA: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-na" */ '@/assets/images/icons/flags/na.svg'
          )
        ).default
      ),
    NR: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-nr" */ '@/assets/images/icons/flags/nr.svg'
          )
        ).default
      ),
    NP: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-np" */ '@/assets/images/icons/flags/np.svg'
          )
        ).default
      ),
    NL: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-nl" */ '@/assets/images/icons/flags/nl.svg'
          )
        ).default
      ),
    BQ: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-bq" */ '@/assets/images/icons/flags/bq.svg'
          )
        ).default
      ),
    NC: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-nc" */ '@/assets/images/icons/flags/nc.svg'
          )
        ).default
      ),
    NZ: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-nz" */ '@/assets/images/icons/flags/nz.svg'
          )
        ).default
      ),
    NI: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-ni" */ '@/assets/images/icons/flags/ni.svg'
          )
        ).default
      ),
    NE: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-ne" */ '@/assets/images/icons/flags/ne.svg'
          )
        ).default
      ),
    NG: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-ng" */ '@/assets/images/icons/flags/ng.svg'
          )
        ).default
      ),
    NU: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-nu" */ '@/assets/images/icons/flags/nu.svg'
          )
        ).default
      ),
    NF: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-nf" */ '@/assets/images/icons/flags/nf.svg'
          )
        ).default
      ),
    MK: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-mk" */ '@/assets/images/icons/flags/mk.svg'
          )
        ).default
      ),
    MP: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-mp" */ '@/assets/images/icons/flags/mp.svg'
          )
        ).default
      ),
    NO: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-no" */ '@/assets/images/icons/flags/no.svg'
          )
        ).default
      ),
    OM: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-om" */ '@/assets/images/icons/flags/om.svg'
          )
        ).default
      ),
    PK: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-pk" */ '@/assets/images/icons/flags/pk.svg'
          )
        ).default
      ),
    PW: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-pw" */ '@/assets/images/icons/flags/pw.svg'
          )
        ).default
      ),
    PS: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-ps" */ '@/assets/images/icons/flags/ps.svg'
          )
        ).default
      ),
    PA: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-pa" */ '@/assets/images/icons/flags/pa.svg'
          )
        ).default
      ),
    PG: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-pg" */ '@/assets/images/icons/flags/pg.svg'
          )
        ).default
      ),
    PY: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-py" */ '@/assets/images/icons/flags/py.svg'
          )
        ).default
      ),
    PE: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-pe" */ '@/assets/images/icons/flags/pe.svg'
          )
        ).default
      ),
    PH: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-ph" */ '@/assets/images/icons/flags/ph.svg'
          )
        ).default
      ),
    PN: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-pn" */ '@/assets/images/icons/flags/pn.svg'
          )
        ).default
      ),
    PL: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-pl" */ '@/assets/images/icons/flags/pl.svg'
          )
        ).default
      ),
    PT: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-pt" */ '@/assets/images/icons/flags/pt.svg'
          )
        ).default
      ),
    PR: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-pr" */ '@/assets/images/icons/flags/pr.svg'
          )
        ).default
      ),
    PR: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-pr" */ '@/assets/images/icons/flags/pr.svg'
          )
        ).default
      ),
    QA: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-qa" */ '@/assets/images/icons/flags/qa.svg'
          )
        ).default
      ),
    RO: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-ro" */ '@/assets/images/icons/flags/ro.svg'
          )
        ).default
      ),
    RU: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-ru" */ '@/assets/images/icons/flags/ru.svg'
          )
        ).default
      ),
    RW: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-rw" */ '@/assets/images/icons/flags/rw.svg'
          )
        ).default
      ),
    RE: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-re" */ '@/assets/images/icons/flags/re.svg'
          )
        ).default
      ),
    BL: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-bl" */ '@/assets/images/icons/flags/bl.svg'
          )
        ).default
      ),
    SH: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-sh" */ '@/assets/images/icons/flags/sh.svg'
          )
        ).default
      ),
    KN: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-kn" */ '@/assets/images/icons/flags/kn.svg'
          )
        ).default
      ),
    LC: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-lc" */ '@/assets/images/icons/flags/lc.svg'
          )
        ).default
      ),
    MF: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-mf" */ '@/assets/images/icons/flags/mf.svg'
          )
        ).default
      ),
    PM: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-pm" */ '@/assets/images/icons/flags/pm.svg'
          )
        ).default
      ),
    VC: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-vc" */ '@/assets/images/icons/flags/vc.svg'
          )
        ).default
      ),
    WS: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-ws" */ '@/assets/images/icons/flags/ws.svg'
          )
        ).default
      ),
    SM: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-sm" */ '@/assets/images/icons/flags/sm.svg'
          )
        ).default
      ),
    ST: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-st" */ '@/assets/images/icons/flags/st.svg'
          )
        ).default
      ),
    SA: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-sa" */ '@/assets/images/icons/flags/sa.svg'
          )
        ).default
      ),
    SN: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-sn" */ '@/assets/images/icons/flags/sn.svg'
          )
        ).default
      ),
    RS: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-rs" */ '@/assets/images/icons/flags/rs.svg'
          )
        ).default
      ),
    SC: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-sc" */ '@/assets/images/icons/flags/sc.svg'
          )
        ).default
      ),
    SL: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-sl" */ '@/assets/images/icons/flags/sl.svg'
          )
        ).default
      ),
    SG: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-sg" */ '@/assets/images/icons/flags/sg.svg'
          )
        ).default
      ),
    SX: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-sx" */ '@/assets/images/icons/flags/sx.svg'
          )
        ).default
      ),
    SK: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-sk" */ '@/assets/images/icons/flags/sk.svg'
          )
        ).default
      ),
    SI: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-si" */ '@/assets/images/icons/flags/si.svg'
          )
        ).default
      ),
    SB: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-sb" */ '@/assets/images/icons/flags/sb.svg'
          )
        ).default
      ),
    SO: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-so" */ '@/assets/images/icons/flags/so.svg'
          )
        ).default
      ),
    ZA: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-za" */ '@/assets/images/icons/flags/za.svg'
          )
        ).default
      ),
    GS: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-gs" */ '@/assets/images/icons/flags/gs.svg'
          )
        ).default
      ),
    SS: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-ss" */ '@/assets/images/icons/flags/ss.svg'
          )
        ).default
      ),
    ES: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-es" */ '@/assets/images/icons/flags/es.svg'
          )
        ).default
      ),
    LK: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-lk" */ '@/assets/images/icons/flags/lk.svg'
          )
        ).default
      ),
    SD: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-sd" */ '@/assets/images/icons/flags/sd.svg'
          )
        ).default
      ),
    SR: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-sr" */ '@/assets/images/icons/flags/sr.svg'
          )
        ).default
      ),
    SJ: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-sj" */ '@/assets/images/icons/flags/sj.svg'
          )
        ).default
      ),
    SE: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-se" */ '@/assets/images/icons/flags/se.svg'
          )
        ).default
      ),
    CH: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-ch" */ '@/assets/images/icons/flags/ch.svg'
          )
        ).default
      ),
    SY: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-sy" */ '@/assets/images/icons/flags/sy.svg'
          )
        ).default
      ),
    TW: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-tw" */ '@/assets/images/icons/flags/tw.svg'
          )
        ).default
      ),
    TJ: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-tj" */ '@/assets/images/icons/flags/tj.svg'
          )
        ).default
      ),
    TZ: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-tz" */ '@/assets/images/icons/flags/tz.svg'
          )
        ).default
      ),
    TH: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-th" */ '@/assets/images/icons/flags/th.svg'
          )
        ).default
      ),
    TL: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-tl" */ '@/assets/images/icons/flags/tl.svg'
          )
        ).default
      ),
    TG: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-tg" */ '@/assets/images/icons/flags/tg.svg'
          )
        ).default
      ),
    TK: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-tk" */ '@/assets/images/icons/flags/tk.svg'
          )
        ).default
      ),
    TO: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-to" */ '@/assets/images/icons/flags/to.svg'
          )
        ).default
      ),
    TT: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-tt" */ '@/assets/images/icons/flags/tt.svg'
          )
        ).default
      ),
    TN: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-tn" */ '@/assets/images/icons/flags/tn.svg'
          )
        ).default
      ),
    TR: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-tr" */ '@/assets/images/icons/flags/tr.svg'
          )
        ).default
      ),
    TR: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-tr" */ '@/assets/images/icons/flags/tr.svg'
          )
        ).default
      ),
    TM: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-tm" */ '@/assets/images/icons/flags/tm.svg'
          )
        ).default
      ),
    TC: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-tc" */ '@/assets/images/icons/flags/tc.svg'
          )
        ).default
      ),
    TV: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-tv" */ '@/assets/images/icons/flags/tv.svg'
          )
        ).default
      ),
    UG: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-ug" */ '@/assets/images/icons/flags/ug.svg'
          )
        ).default
      ),
    UA: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-ua" */ '@/assets/images/icons/flags/ua.svg'
          )
        ).default
      ),
    AE: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-ae" */ '@/assets/images/icons/flags/ae.svg'
          )
        ).default
      ),
    GB: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-gb" */ '@/assets/images/icons/flags/gb.svg'
          )
        ).default
      ),
    US: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-us" */ '@/assets/images/icons/flags/us.svg'
          )
        ).default
      ),
    UY: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-uy" */ '@/assets/images/icons/flags/uy.svg'
          )
        ).default
      ),
    UZ: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-uz" */ '@/assets/images/icons/flags/uz.svg'
          )
        ).default
      ),
    VU: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-vu" */ '@/assets/images/icons/flags/vu.svg'
          )
        ).default
      ),
    VE: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-ve" */ '@/assets/images/icons/flags/ve.svg'
          )
        ).default
      ),
    VN: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-vn" */ '@/assets/images/icons/flags/vn.svg'
          )
        ).default
      ),
    VG: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-vg" */ '@/assets/images/icons/flags/vg.svg'
          )
        ).default
      ),
    VI: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-vi" */ '@/assets/images/icons/flags/vi.svg'
          )
        ).default
      ),
    WF: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-wf" */ '@/assets/images/icons/flags/wf.svg'
          )
        ).default
      ),
    EH: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-eh" */ '@/assets/images/icons/flags/eh.svg'
          )
        ).default
      ),
    YE: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-ye" */ '@/assets/images/icons/flags/ye.svg'
          )
        ).default
      ),
    ZM: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-zm" */ '@/assets/images/icons/flags/zm.svg'
          )
        ).default
      ),
    ZW: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-zw" */ '@/assets/images/icons/flags/zw.svg'
          )
        ).default
      ),
    AX: async () =>
      ensureUniqId(
        (
          await import(
            /* webpackChunkName: "kr-asset-flag-ax" */ '@/assets/images/icons/flags/ax.svg'
          )
        ).default
      )
  }
}
